import { SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { CrmColors } from '../../crm-theme';

/// Status selecionado fica tingido na cor dele: é o filtro de status ligado.
export const statusMetricSx = (cc: CrmColors, color: string, selected: boolean): SxProps<Theme> => ({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    px: 0.9,
    py: 0.25,
    borderRadius: '7px',
    border: `1px solid ${selected ? color : 'transparent'}`,
    bgcolor: selected ? alpha(color, 0.16) : 'transparent',
    transition: 'background-color .15s, border-color .15s',
    '&:hover': { bgcolor: selected ? alpha(color, 0.22) : cc.countBg },
    '&:focus-visible': { outline: `2px solid ${color}`, outlineOffset: '1px' },
});
